<template>
	<div class="non-bind-mask">
		<div class="mask-content">
			<img src="@/assets/qualificationQuery/vip_icon.png" alt="" />
			<p>您尚未登录账号，请登录后进行查看</p>
			<router-link to="/login">
				立即登录
				<i class="el-icon-arrow-right"></i>
			</router-link>
		</div>
	</div>
</template>

<script>
	// 未登录提示
	export default {
		name: 'NonbindUser',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
